import React, { useMemo } from 'react';
import DayCell from './DayCell';
import FitScoreTooltip from '../../components/shoots/FitScoreTooltip';

const CrewPlannerRow = React.memo(({ shooter, dates, onCellClick }) => {
	const totalEvents = useMemo(() => {
		return dates.reduce((sum, date) => {
			const dateInfo = shooter.dates.find((d) => d.date === date);
			return sum + (dateInfo?.events?.length || 0);
		}, 0);
	}, [shooter.dates, dates]);

	return (
		<div className="crew-planner-row">
			<div className="crew-planner-name-col" onClick={() => onCellClick(shooter, dates[0])}>
				<FitScoreTooltip fitScore={shooter.fitScore} fitReasons={shooter.fitReasons} name={shooter.name}>
					<span className="shooter-name">{shooter.name}</span>
				</FitScoreTooltip>
				{shooter.isFreelancer && <span className="freelancer-badge">Freelancer</span>}
			</div>
			{dates.map((date) => {
				const dateInfo = shooter.dates.find((d) => d.date === date);
				return (
					<div key={date} className="crew-planner-date-col">
						<DayCell
							status={dateInfo?.status || 'AVAILABLE'}
							events={dateInfo?.events || []}
							date={date}
							onClick={() => onCellClick(shooter, date)}
						/>
					</div>
				);
			})}
			<div className="crew-planner-total-col">
				<span className={`total-count ${totalEvents > 0 ? 'has-events' : ''}`}>{totalEvents}</span>
			</div>
		</div>
	);
});

export default CrewPlannerRow;
